import { AuthenticationClient } from '../authentication/client';
import { isInternal, isProxyUser } from '../authentication/utils';

import { Filter, FilterAccess } from './types';

/**
 * Checks if current user is the owner of the filter and can share it.
 * @param filter the filter to check
 * @returns true, if the current user can share the filter, false otherwise
 */
export const canShareFilter = (filter: Filter): boolean => {
  const user = AuthenticationClient.getInstance().getUser();

  if (!user || isInternal(user) || isProxyUser(user)) {
    return false;
  }

  return filter.permissions.some(x => x.access === FilterAccess.Owner && x.user.id === user?.userId);
};
